<template>
	<div ref="view" id="search-default" v-bind:class="getMainClass()">
		<searchInput :placeholder="placeholder" :results="results" :hasResults="hasResults"/>
	</div>
</template>

<script>

import searchInput from './search-input';

export default {
	name:'search-default',
	data: function(){
		return {
			results:null,
			hasResults:true,
			placeholder:'Search address or APN',
			searchTermPrev:null
		}
	},
	components:{
		searchInput
	},
	computed: {
		searchTerm:function(){
			return this.$store.state.search.term;
		},
		searchType:function(){
			return this.$store.state.search.type;
		},
		deviceType:function(){
			return this.$store.state.device.type;
		}
	},
	created:function(){
		// todo: check if this reroute is useful in a certain scenario - removed to clear out the search when directed from parcel to permit
		/*
		if (this.searchTerm && this.$router.currentRoute.name === 'home'){
			const route = {
				name: 'search', 
				params:{
					search:this.searchTerm
				}
			};
			this.$router.replace(route);
			return;
		}
		*/
		if (this.$router.currentRoute.params.search && this.$router.currentRoute.params.search.length > 0){
			this.$store.dispatch('SEARCH_TERM_SET', {
				term:this.$router.currentRoute.params.search
			});
			return;
		}

		this.checkSearch();
	},
	mounted: function (){
		this.handleResize();
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy: function(){
		this.$store.dispatch('SEARCH_TERM_SET',{term:''});
	},
	destroyed: function (){
		window.removeEventListener('resize', this.handleResize);
		this.searchTermPrev = null;
	},

	methods:{
		getMainClass:function(){
			if (this.deviceType === 'mobile'){
				return '';
			}
			return 'col-md-6 col-lg-5 col-xl-4 px-2';
		},
		checkSearch:function(){
			if (this.searchTermPrev !== this.searchTerm || !this.results || this.searchType !== 'parcel'){
				this.searchTermPrev = this.searchTerm;
				this.search();
			}
		},
		handleResize:function(){
			if (!this.$refs['view']) return;
			if (this.deviceType !== 'mobile'){
				let w = this.$refs['view'].offsetWidth+60; // width of nav bar + margin
				//console.log('w:',w);
				this.$store.dispatch('MAP_LEFT_MARGIN_SET', {leftMargin:w});
			} else {
				this.$store.dispatch('MAP_LEFT_MARGIN_SET', {leftMargin:0});
			}
		},
		search:function(){
			this.$store.dispatch('SEARCH', {
				query: this.searchTerm,
				type:'parcel'
			}).then((data)=>{

				let results = [];
				data && data.forEach((rec)=>{
					let res = {
						id:rec.id,
						title:rec.full
					};

					res.subtitle = `${rec.jurisdiction || ''} ${rec.state || ''} ${rec.postal || ''}`;
					res.footer = `APN: ${rec.apnFmt || ''}`;
					res.route = {
						name: 'parcels', 
						params:{
							id: rec.parcelId
						},
						query:{
							addressId:rec.id
						}
					};
					results.push(res);
				});

				if (results.length < 1 && !this.searchTerm){
					results = this.$store.getters.getSearchResultsSelected();
				}

				this.$data.results = results;

            this.$store.dispatch('SEARCH_RESULTS_SET', {results:data});
			}).catch((e)=>{
				console.error(e);
			});
		}
	},

	watch: {
		'$route':function(newRoute,oldRoute){
			if (newRoute.params.search && newRoute.params.search !== this.searchTerm){
				this.$store.dispatch('SEARCH_TERM_SET', {
					term:newRoute.params.search
				});
				return;
			}
			this.checkSearch();
		},
		searchTerm: function(newTerm, oldTerm){
			if (!newTerm && this.$router.currentRoute.name === 'search'){
				const route = {
					name: 'home', 
					params:{
					}
				};
				this.$router.push(route);
				return;
			} else if ((this.$router.currentRoute.name === 'home' || this.$router.currentRoute.name === 'search') && newTerm && newTerm.length > 0){
				const route = {
					name: 'search', 
					params:{
						search:newTerm
					}
				};
				this.$router.replace(route);
				return;
			}
			this.checkSearch();
			
		}
	}
}
</script>

<style>
.desktop #search-default {
   position:fixed;
	left:55px;
	top:0.5rem;
	z-index:1000;
}
</style>


// WEBPACK FOOTER //
// src/components/search/search-default.vue